import Link from "next/link";

import React, { useMemo } from "react";

import { isBefore } from "date-fns";
import addMonths from "date-fns/addMonths";
import format from "date-fns/format";
import { Entity } from "models/entity";

import { useApi } from "hooks/useApi";
import { baseFetcher } from "utils/baseFetcher";

import { consensusDividendPaymentsUrl } from "../utils";

const DEFAULT_START_DATE = addMonths(new Date(), -6);
const DEFAULT_END_DATE = addMonths(new Date(), 6);

interface NextDividendExTextProps {
  entity: Entity;
  startDate?: Date;
  endDate?: Date;
}

const NextDividendExText = ({
  entity,
  startDate = DEFAULT_START_DATE,
  endDate = DEFAULT_END_DATE,
}: NextDividendExTextProps) => {
  const { data: dividendPayments, isValidating } = useApi(
    consensusDividendPaymentsUrl(entity.id, startDate, endDate),
    baseFetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const latestDate = useMemo(
    () => (dividendPayments?.graph?.date || []).sort().reverse()[0],
    [dividendPayments?.graph?.date]
  );

  if (
    isValidating ||
    !latestDate ||
    isBefore(new Date(latestDate), new Date())
  ) {
    return <div className="md:h-[20px]" />;
  }

  return (
    <div className="flex items-center">
      <div className="hidden md:block mx-[5px]">•</div>
      <Link
        href={`/entities/${entity.slug}/analytics?tab=financials#dividend`}
        className="hover:underline flex space-x-[5px] text-[13px] md:text-[14px]"
      >
        <span className="font-medium">Next Ex-Dividend:</span>
        <span>{format(new Date(latestDate), "dd MMM yyyy")}</span>
      </Link>
    </div>
  );
};

export default NextDividendExText;
